import AScene from "../../library/ExtendedObjects/AScene"
import gameData from "../../gameData.js";
import LocationData from "../../scenes/Cand/LocationData.js";
import ABCyaPhaser, { Audio } from "@abcya/abcya_phaser";
import FontKeys from "../../FontKeys.js";
import ABCyaLib from "@abcya/abcya_lib";


export default class EndCake extends AScene
{
    static get KEY() { return 'EndCake'; }
    init(data)
    {
        ////console.log('init',data);
        this.CandleTop = data.Candle;
    }

    create()
    {
        //var User = this.add.renderTexture(0,0,1094,728);
        var CakeTest;
        //console.log(this.CandleTop);
        /*
        this.textures.addBase64('snap1',this.SentCake);
                    this.textures.once('addtexture',()=>
                    {
                        CakeTest = this.add.image(200,0,'snap1');
                        //console.log("image added");
                    });
                    */

        var User = this.add.image(505,531,'snap');
        //CakeTest.setDepth(40);

        //CakeTest.setScale(.35);
        

        //Candle Constraint Shape and mask shape
        var Graphic = this.add.graphics({ lineStyle: {color: 0x00aaaa } });
        var Shape = this.make.graphics();
        var EllipseBottom;
        var RectCenter;
        var FlameArray = [];

        Shape.fillStyle(0xffffff);
        Shape.beginPath();
        //Shape.fillRect(this.mid.x,this.mid.y,400,600);
        this.ellipse = new Phaser.Geom.Ellipse(668, 523, 484, 122);
        EllipseBottom = new Phaser.Geom.Ellipse(668, 255, 484, 122);
        RectCenter = new Phaser.Geom.Rectangle(427, 255, 483, 268);
        Shape.fillEllipseShape(this.ellipse);

        //Graphic.fillEllipseShape(EllipseBottom);
        //Graphic.fillEllipseShape(this.ellipse);
        //Graphic.fillRectShape(RectCenter);

        Shape.fillEllipseShape(EllipseBottom);
        Shape.fillRectShape(RectCenter);

        Shape.setDepth(30);
        Graphic.setDepth(30);
        Graphic.setScale(.5);
        Shape.setScale(.5);

        Graphic.x += 177.5;
        Graphic.y += 340;
        Shape.x += 177.5;
        Shape.y += 340;

        this.CakeMask = Shape.createGeometryMask();
        
        this.count1 = 0;
        var CakePlace = [];
        var CakeGroupLeft = [];
        var CakeGroupRight = [];
        this.FinalCakesArray = [];
        this.RopeArray = [];
        var GroupLeftTween;
        var CakeRightTween;
        var UserTween;
        var BtmCake;

        this.UserContainer = this.add.container();

        this.UserContainer.add(User);
        User.setScale(.5);

        let {KidCakePair, CandleLocation} = LocationData.CKCLocations();

        this.KidCakePair = KidCakePair;
        this.DepthList = LocationData.DepthListSend();

        var BackGround = this.addImage(this.mid.x, this.mid.y, "G_bg", this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
        var YellowBack = this.addImage(this.mid.x, this.mid.y, "Background.png");
        this.TableImage = this.addImage(this.mid.x, this.mid.y + this.mid.y - 175, "Table.png");
        
        CakePlace[0] = this.addImage(711,685.7604562737644, "Cake_1.png");
        CakePlace[1] = this.addImage(502,703, "Cake_2.png");
        CakePlace[2] = this.addImage(223.58174904942973,550.0000000000001, "Cake_3.png");
        CakePlace[3] = this.addImage(92.15589353612178,620.2243346007606, "Cake_4.png");
        CakePlace[4] = this.addImage(801.93536121673,536.3840304182509, "Cake_6.png");
        CakePlace[5] = this.addImage(900,636.3041825095056, "Cake_8.png");
        CakePlace[6] = this.addImage(281.2889733840304,674.2053231939163, "Cake_9.png");

        if (this.CandleTop.length != 0)
        {
    
            for(let x = 0; x < this.CandleTop.length;x++)
            {
                //console.log(this.CandleTop[x].Xcord);
                //this.addImage(100,100, this.CandleTop[x].Name);
                FlameArray[x] = this.addImage(User.getTopLeft().x + ((this.CandleTop[x].Xcord - 314)*.5),User.getTopLeft().y + (this.CandleTop[x].Ycord*.5), this.CandleTop[x].Name);
                //FlameArray[x].setDepth(30);
                
                FlameArray[x].setScale(.5);

                if(this.CandleTop[x].Name != "Decorations/Candles/Cndl_Fire_1.png")
                {
                    FlameArray[x].setOrigin(.5,1);
                    this.CandleFireIdleTween(FlameArray[x]);
                }
                else
                {
                    FlameArray[x].setOrigin(.45,.49);
                    this.addRepeatingEvent(100,()=>
                    {
                        FlameArray[x].setRotation(Math.random());
                    },-1);
                }
                this.UserContainer.add(FlameArray[x]);
            }
        }

        this.UserContainer.setVisible(false);
        
        YellowBack.setDepth(1);
        
        BackGround.setDepth(this.DepthList.Background);

        for (let x = 0; x < 7; x++)
        {
            CakePlace[x].setScale(.38);
            CakePlace[x].setDepth(0);
        }

        CakeGroupLeft = [CakePlace[2],CakePlace[3],CakePlace[6]];
        CakeGroupRight = [CakePlace[4],CakePlace[5],CakePlace[0]];

        this.SoundCheck("tween_down");
        this.addTween(YellowBack,1000,{y:1000},Phaser.Math.Easing.Quadratic.InOut,()=>
        {
            this.FinalScreenKidEnter();

            this.addTween(this.CakeMask, 900, {y: {start: this.CakeMask.y + 600, to: this.CakeMask.y}},Phaser.Math.Easing.Quadratic.InOut);
            UserTween = this.addTween(this.UserContainer, 900, {y: {start: this.UserContainer.y + 600, to: this.UserContainer.y}},Phaser.Math.Easing.Quadratic.InOut);
            //For user cake group
            UserTween.on('start',()=>
            {
                this.SoundCheck("cake_slide_in");
                this.UserContainer.setVisible(true);
                this.UserContainer.setDepth(this.DepthList.TweenFire);
                BtmCake = this.addTween(CakePlace[1], 900, {y: {start: CakePlace[1].y + 600, to: CakePlace[1].y}, delay:50},Phaser.Math.Easing.Quadratic.InOut);
                BtmCake.on('start',()=>
                {
                    CakePlace[1].setDepth(this.DepthList.Cake);
                });
            });

            //For Left and right cake groups
            for (let x = 0; x<3; x++)
            {
                GroupLeftTween = this.addTween(CakeGroupLeft[x], 900, {x:{start: CakeGroupLeft[x].x-400, to: CakeGroupLeft[x].x}},Phaser.Math.Easing.Quadratic.InOut);
                GroupLeftTween.on('start',()=>
                {
                    CakeGroupLeft[x].setDepth(12+x);
                });
            }

            for (let x = 0; x<3; x++)
            {
                CakeRightTween = this.addTween(CakeGroupRight[x], 900, {x:{start: CakeGroupRight[x].x+400, to: CakeGroupRight[x].x}},Phaser.Math.Easing.Quadratic.InOut);
                CakeRightTween.on('start',()=>
                {
                    CakeGroupRight[x].setDepth(12+x);
                });
            }

            //this.FinalTable(737);
        });
        /*
        this.input.keyboard.on('keydown', ()=> {
            //console.log(event.key);
            if (event.key != "Tab")
            {
                for(let x in this.FinalCakesArray)
                {
                    //console.log("this.addImage("+this.FinalCakesArray[x].x+","+this.FinalCakesArray[x].y+", \""+this.FinalCakesArray[x].frame.name+"\");");
                }
            }
        });
        */

        this.CakeMask = Shape.createGeometryMask();

        //BackGround.setMask(this.CakeMask);

        this.TableImage.setDepth(this.DepthList.Table);
    }

    CandleFireIdleTween(ToTween)
        {
                var RandomTimeFlame = Math.floor(Math.random() * 800)+1100;
                var RandomTimeFlameRotate = Math.floor(Math.random() * 800)+1100;
                var fire5 = ToTween;
                var FlameScale = ToTween.scale;

                //this.addTween(ToTween, 100, {y: ToTween.y + 4, yoyo:true, loop: -1, delay: RandomTimeFlame}, Phaser.Math.Easing.Quadratic.In);
                //this.addTween(ToTween, 50, {rotation: {start: ToTween.rotation, from: ToTween.rotation+.09, to: ToTween.rotation-.1}, yoyo:true, loop: -1, delay: RandomTimeFlameRotate}, Phaser.Math.Easing.Quadratic.In);
        
                var Flamen = this.addTween(fire5, 100, {scaleY:FlameScale + .14, yoyo: true},Phaser.Math.Easing.Bounce.Quadratic,()=>{
                    switch(Math.floor(Math.random()*3))
                    {
                        case 0:
                            this.addTween(fire5, 100, {scaleY:FlameScale + .1, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                                break;
                        case 1:
                            this.addTween(fire5, 60, {scaleY:FlameScale - .1, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                            break;
                        case 2:
                            this.addTween(fire5, 50, {scaleY:FlameScale + .05, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                            break;
                    }
                });
        }

    FinalTable(Distance)
        {
            var i = 0;
            var DepthList = [2,2,1,2,1,1,2,2,1,1]
            var CakeLocations = LocationData.FinalScreenCakeLocations();
            if (gameData.gameMuted != true)
            {
                //this.playSound("tween_up");
            }
            for (i = 0; i < 5; i++)
            {
                this.FinalCakesArray[i] = this.addImage(CakeLocations[i][0],CakeLocations[i][1] + Distance,("Cake_"+(i+1)+".png"));
                this.FinalCakesArray[i].scale = .38;
                this.FinalCakesArray[i].setDepth(this.DepthList.FireBehind + DepthList[i]);
                this.addTween(this.FinalCakesArray[i], 600, {y: CakeLocations[i][1]}, Phaser.Math.Easing.Quadratic.Out);
            }

            for (i = 5; i < 10; i++)
            {
                this.FinalCakesArray[i] = this.addImage(CakeLocations[i][0]+Distance,CakeLocations[i][1],("Cake_"+(i+1)+".png"));
                this.FinalCakesArray[i].scale = .38;
                this.FinalCakesArray[i].setDepth(this.DepthList.FireBehind + DepthList[i]);
                this.addTween(this.FinalCakesArray[i], 600, {x: CakeLocations[i][0]}, Phaser.Math.Easing.Quadratic.Out);
            }
        }

    FinalScreenKidEnter()
        {
            var i;
            var FinalKidsArray = [];
            var FinalKidsArrayOrder = [0,6,4,8,2,7,3,9,1,5];
            var FinalKidsLocation = LocationData.FinalScreenKidLocations();
            var DistanceOffscreenLeft;
            var kid;
            var eye1;
            var eye2;
            var WellDoneText;
            var Party;

            DistanceOffscreenLeft = (95+FinalKidsLocation[4][0]);
            for (i = 0; i < 10; i++)
            {
                
                if (i >= 5)
                {
                    FinalKidsArray[i] = this.add.container(FinalKidsLocation[i][0],FinalKidsLocation[i][1]);
                    kid = this.addImage(0,0, ("NewAsset/Kids_"+((FinalKidsArrayOrder[i])+1)+".png"),FinalKidsArray[i]);
                    eye1 = this.addImage((this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[1]), 0-(this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[2]), ("NewAsset/Kids_"+((FinalKidsArrayOrder[i])+1)+"_Eye.png"),FinalKidsArray[i]);
                    eye2 = this.addImage(-(this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[0]), 0-(this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[2]), ("NewAsset/Kids_"+((FinalKidsArrayOrder[i])+1)+"_Eye.png"),FinalKidsArray[i]);
                    kid.flipX = true;
                    FinalKidsArray[i].setVisible(false);
                    this.EndScreenWalkRightIn(FinalKidsArray[i],FinalKidsLocation[i][0]);   
                }

                else
                {
                    FinalKidsArray[i] = this.add.container(FinalKidsLocation[i][0],FinalKidsLocation[i][1]+50);
                    kid = this.addImage(0,0, ("NewAsset/Kids_"+((FinalKidsArrayOrder[i])+1)+".png"),FinalKidsArray[i]);
                    eye1 = this.addImage((this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[0]), 0-(this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[2]), ("NewAsset/Kids_"+((FinalKidsArrayOrder[i])+1)+"_Eye.png"),FinalKidsArray[i]);
                    eye2 = this.addImage(-(this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[1]), 0-(this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[2]), ("NewAsset/Kids_"+((FinalKidsArrayOrder[i])+1)+"_Eye.png"),FinalKidsArray[i]);
                    FinalKidsArray[i].setVisible(false);
                    this.EndScreenWalkLeft(FinalKidsArray[i],FinalKidsLocation[i][0]);
                    
                }
                FinalKidsArray[i].scale = .55;
                FinalKidsArray[i].setDepth(this.DepthList[(FinalKidsLocation[i][2])]);
            }
           
            this.addDelay(1530,()=>
            {
                this.SummonEndBalloons();
            });
            
                //this.EndKidBounce(FinalKidsArray);
            //});

            this.addDelay(1700,()=>{
                this.EndKidBounce(FinalKidsArray);
            });
        }

        EndScreenWalkRightIn(Tweened,ToX)
        {

            
            //this.addTween(Tweened,200,{x: {start: ToX+500, to: ToX-300}});
            var ForwardTween;
            this.addTween(Tweened,200,{y:Tweened.y - 5, scaleX: .52, scaleY:.58, loop:-1,yoyo: true});
            ForwardTween = this.addTween(Tweened,1600,{x: {start: ToX + 500, to: ToX}},Phaser.Math.Easing.Quadratic.Out,()=>{
                this.tweens.killTweensOf(Tweened);
                //this.addTween(Tweened,150,{y: Tweened.y + .5, scaleX:.559, scaleY:.541, yoyo: true},Phaser.Math.Easing.Quadratic.Out);
            });
            ForwardTween.on('start',()=>{Tweened.setVisible(true);});
        }

    EndScreenWalkLeft(Tweened,ToX)
        {

            
            //this.addTween(Tweened,200,{x: {start: ToX+500, to: ToX-300}});
            var ForwardTween;
            this.addTween(Tweened,200,{y:Tweened.y - 5, scaleX: .52, scaleY:.58, loop:-1,yoyo: true});
            ForwardTween = this.addTween(Tweened,1600,{x: {start: ToX - 500, to: ToX}},Phaser.Math.Easing.Quadratic.Out,()=>{
                this.tweens.killTweensOf(Tweened);
            });
            ForwardTween.on('start',()=>{Tweened.setVisible(true);});
        }

    EndKidBounce(Kids)
        {
            var RandomHeight;
            var x;
            var RandomTime;
            var RandomDelay = 200;
            var Time;
            var Stretch;
            var JumpSquat = [];
            var RandomBlinkTime;
            var Tween;
            var PreStretch = .02;


            for (x in Kids)
            {
                RandomDelay = 200;
                RandomTime = Math.floor(Math.random() * 100)+300;
                RandomHeight = Math.floor(Math.random() * 20)+30;
                RandomDelay += Math.floor(Math.random() * 500)+100;
                RandomBlinkTime = (Math.floor(Math.random() * 1000) + 1500);

                Time = RandomHeight*5;
                Stretch = RandomHeight*.0004;

                JumpSquat[x] = this.tweens.createTimeline()
                JumpSquat[x].loop = -1;
                JumpSquat[x].loopDelay = RandomTime;

                
                JumpSquat[x].add({targets: Kids[x], duration: 100,delay: RandomDelay, scaleY: Kids[x].scaleY - PreStretch, scaleX: Kids[x].scaleX + PreStretch, hold:100, yoyo: true, ease: 'Quadatic'});
                JumpSquat[x].add({targets: Kids[x], duration: 200, scaleY: Kids[x].scaleY + Stretch, scaleX: Kids[x].scaleX - Stretch, y: Kids[x].y - 60, ease: 'Quadratic',yoyo: true});
                JumpSquat[x].add({targets: Kids[x], duration: 90, scaleY: Kids[x].scaleY - Stretch, scaleX: Kids[x].scaleX + Stretch, yoyo: true,});
                JumpSquat[x].play();

                RandomTime = Math.floor(Math.random() * 1000)+50;

                Tween = this.add.tween({targets: [ Kids[x].list[1], Kids[x].list[2] ],duration:7, delay: RandomTime, scaleY: .2,loop: -1, yoyo: true, hold:80, loopDelay: RandomBlinkTime +1000});
            }
            //console.log(Kids[1].list[0]); 
        }

    SummonEndBalloons()
        {
            var PlayABalloon;
            var MakeBalloon;
            var EndBalloonGroup = this.add.group();
            var BalloonArray = [];
            var StringArray = [];
            var BalloonRiseSound;

            MakeBalloon = this.add.container(745,168, 
            [
              this.addImage(0,0,"NewAsset/Decorate_Cake_Balloon.png"),
              ABCyaPhaser.Text.addText(2,18, ABCyaLib.Environment.instance.gameConfig.decorateAnotherCakeTextFontSize, 0xd4d2ff,FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("make_a_cake_screens.decorate_another_cake_balloon"), this).setOrigin(0.5, 0).setShadow(-2,2, "#7753db").setWordWrapWidth(160).setLineSpacing(-10)
            ]);

            PlayABalloon = this.add.container(279,168, 
            [
              this.addImage(0,0,"NewAsset/Play_Again_Balloon.png"),
              ABCyaPhaser.Text.addText(2,45, 32, 0xd4d2ff,FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("well_done_screen.play_again_balloon"), this).setShadow(-2,2, "#7753db").setWordWrapWidth(150).setLineSpacing(-10)
            ]);
            
            this.RopeArray = [];

            BalloonArray = [PlayABalloon, MakeBalloon];

            this.RopeArray[0] = StringArray[0] = this.add.rope(BalloonArray[0].x+5, BalloonArray[0].y+200, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
            this.RopeArray[1] = StringArray[1] = this.add.rope(BalloonArray[1].x+5, BalloonArray[1].y+200, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);

            for(let x in StringArray)
            {
                StringArray[x].setColors(0x7753db);
                StringArray[x].y += 800;
                this.addTween(StringArray[x],2500,{y:StringArray[x].y - 800},Phaser.Math.Easing.Quadratic.InOut);
                StringArray[x].setDepth(this.DepthList.EndString);
            }

            EndBalloonGroup.addMultiple([PlayABalloon,MakeBalloon]);

            PlayABalloon.setDepth(this.DepthList.Instructions);
            MakeBalloon.setDepth(this.DepthList.Instructions);
            
            PlayABalloon.on('pointerdown',()=>
            {

                this.scene.start("Intro");

            });

            MakeBalloon.on('pointerdown',()=>
            {
                this.ToOtherScene();
                this.addDelay(800,()=>
                {
                    this.scene.start("MakeACake");
                });
            });

            this.addDelay(300,()=>
            {
                if (gameData.gameMuted != true)
                {
                    BalloonRiseSound = this.playSound("balloons_rising",1);
                }
            });

            this.addDelay(2010,()=>
            {
                this.playSound("play_again_or_decorate_cake", 1, false, true, Audio.LOCALIZATION_AUDIO_SPRITE);
            });
            
            EndBalloonGroup.getChildren().forEach((child)=>
            {
                //console.log(child);
                child.y += 800;
                this.addTween(child,2500,{y:child.y - 800},Phaser.Math.Easing.Quadratic.InOut,()=>{
                    ABCyaPhaser.Container.setContainerInteractive(MakeBalloon, false);
                    ABCyaPhaser.Container.setContainerInteractive(PlayABalloon, false);
                    this.EndBalloonBounce(StringArray, BalloonArray);
                });
            });
        }
        
    EndBalloonBounce(string,Balloon)
        {
            var RandomBalloonHeight;
            var x;
            var RandomTime;
            for (x in Balloon)
            {
                RandomTime = Math.floor(Math.random() * 500)+1100;
                RandomBalloonHeight = Math.floor(Math.random() * 10)+5;
                this.addTween(Balloon[x], RandomTime, {y: Balloon[x].y + RandomBalloonHeight, yoyo: true, loop: -1},Phaser.Math.Easing.Quadratic.InOut);
                this.addTween(string[x], RandomTime, {y: string[x].y + RandomBalloonHeight, yoyo: true, loop: -1},Phaser.Math.Easing.Quadratic.InOut);
            }
        }

    ToOtherScene()
        {
            let bg = this.addImage(this.mid.x, this.mid.y+this.mid.y+this.mid.y, "Background.png");
            bg.setDepth(this.DepthList.YesNoBtn);
            this.addTween(bg,800,{x:this.mid.x,y:this.mid.y},Phaser.Math.Easing.Quadratic.Out);
        }

    BlinkEye(Eye1,Eye2)
        {
            var RandomBlinkTime = (Math.floor(Math.random() * 1000) + 1500);
            this.addDelay(RandomBlinkTime, ()=>{
                
                Eye1.setScale(1,.2);
                Eye2.setScale(1,.2);
                this.addDelay(90,()=>
                {
                    Eye1.setScale(1,1);
                    Eye2.setScale(1,1);
                });

                this.addDelay(RandomBlinkTime+1000, ()=>{
                    if (this.GameWin != 1)
                    {
                        this.BlinkEye(this.Eye2,this.Eye1);
                    }
                });
            });
        }

    SoundCheck(sound)
        {
            if (gameData.gameMuted != true)
            {
                this.playSound(sound);
            }
        }
        
    update()
        {

            this.count1 += .1;

            if(this.RopeArray.length===2)
            {
                var points = [
                    this.RopeArray[0].points,
                    this.RopeArray[1].points,
                ];

                for (let i = 7; i < points[0].length; i++)
                {
                        points[0][i].x = Math.sin(i * .3 - this.count1) * 3;
                }
                this.RopeArray[0].setDirty();


                //let points1 = this.RopeArray[1].points;

                for (let i = 7; i < points[1].length; i++)
                {
                        points[1][i].x = Math.sin(i * .27 - this.count1) * 2.9;
                }
                this.RopeArray[1].setDirty();

            }
        }
}